import React from 'react';

import type { TextBlock } from '@/types/pageContentTypes';

interface HeroBadgeProps {
  badge?: TextBlock;
  testId?: string;
}

const DEFAULT_BADGE_CLASS_NAME =
  'inline-flex items-center rounded-[8px] border border-theme-primary text-theme-primary bg-transparent px-4 py-2 text-xs md:text-sm font-mulish font-medium leading-none whitespace-nowrap';

const HeroBadge: React.FC<HeroBadgeProps> = ({
  badge,
  testId = 'hero-badge',
}) => {
  if (!badge?.content) return null;

  const badgeItems = badge.content
    .split('|')
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div
      data-testid={testId}
      className="flex w-full flex-wrap items-center gap-2"
    >
      {badgeItems.map((text, index) => (
        <div
          key={index}
          data-testid={`${testId}-item-${index}`}
          className={badge.styles?.p ?? DEFAULT_BADGE_CLASS_NAME}
        >
          {text}
        </div>
      ))}
    </div>
  );
};

export default HeroBadge;
